/* eslint-disable */

import {VisitStatus} from "app/core/enum/visit-status.enum";

/* eslint-disable */
export const visitStatus3 = [
    {
        oid: "00000001-0000-0000-0000-000000000000",
        sort: 1,
        visit_status: VisitStatus.SCHEDULE,
        tooltip: "Schedule - Visit needs to be scheduled",
        name: "Schedule",
        code: "Sc",
        status: "schedule",
        icon: "davesa:visit-schedule",
        icon2: "davesa:v-schedule",
        icon3: "mat_solid:check",
        textClass: "text-emerald-100",
        bgClass: "bg-emerald-100",
        textClassContrast: "text-gray-900",
        bgClassContrast: "bg-gray-900",
        bgColor: "#d0fae5",
    },
    {
        oid: "00000002-0000-0000-0000-000000000000",
        sort: 2,
        visit_status: VisitStatus.UNCONFIRMED,
        old: "schedule",
        tooltip: "Unconfirmed - Visit needs to be confirmed byu Participant",
        name: "Unconfirmed",
        code: "Un",
        status: "unconfirmed",
        icon: "davesa:visit-unconfirmed",
        icon2: "davesa:v-unconfirmed",
        icon3: "mat_solid:check",
        textClass: "text-emerald-200",
        bgClass: "bg-emerald-200",
        textClassContrast: "text-gray-900",
        bgClassContrast: "bg-gray-900",
        bgColor: "#a4f4cf",

    },
    {
        oid: "00000003-0000-0000-0000-000000000000",
        sort: 3,
        visit_status: VisitStatus.CONFIRMED,
        tooltip: "Confirmed - Visit has been confirmed by Participant",
        name: "Confirmed",
        code: "Co",
        status: "confirmed",
        icon: "davesa:visit-confirmed",
        icon2: "davesa:v-confirmed",
        icon3: "mat_solid:check",
        textClass: "text-emerald-300",
        bgClass: "bg-emerald-300",
        textClassContrast: "text-gray-900",
        bgClassContrast: "bg-gray-900",
        bgColor: "#5ee9b5",

    },
    {
        oid: "00000004-0000-0000-0000-000000000000",
        sort: 4,
        visit_status: VisitStatus.RESCHEDULE,
        tooltip: "Reschedule - Visit needs to be rescheduled",
        name: "Reschedule",
        code: "Re",
        status: "reschedule",
        icon: "davesa:visit-reschedule",
        icon2: "davesa:v-reschedule",
        icon3: "mat_solid:check",
        textClass: "text-emerald-400",
        bgClass: "bg-emerald-400",
        textClassContrast: "text-gray-900",
        bgClassContrast: "bg-gray-900",
        bgColor: "#00d492",

    },
    {
        oid: "00000005-0000-0000-0000-000000000000",
        sort: 5,
        visit_status: VisitStatus.ABSENT,
        tooltip: "Absent - Participant was did not show up for the visit",
        name: "Absent",
        code: "Ab",
        status: "absent",
        icon: "davesa:visit-absent",
        icon2: "davesa:v-absent",
        icon3: "mat_solid:check",
        textClass: "text-emerald-500",
        bgClass: "bg-emerald-500",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#00bc7d",

    },
    {
        oid: "00000006-0000-0000-0000-000000000000",
        sort: 6,
        visit_status: VisitStatus.MISSED,
        tooltip: "Missed - Visit was approved as missed by Sponsor",
        name: "Missed",
        code: "Mi",
        status: "missed",
        icon: "davesa:visit-missed",
        icon2: "davesa:v-missed",
        icon3: "mat_solid:check",
        textClass: "text-emerald-600",
        bgClass: "bg-emerald-600",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#009966",

    },
    {
        oid: "00000007-0000-0000-0000-000000000000",
        sort: 7,
        visit_status: VisitStatus.CLINIC,
        tooltip: "Clinic - Participant is in the Clinic now",
        name: "Clinic",
        code: "Cl",
        status: "clinic",
        icon: "davesa:visit-clinic",
        icon2: "davesa:v-clinic",
        icon3: "mat_solid:check",
        textClass: "text-emerald-700",
        bgClass: "bg-emerald-700",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#007a55",

    },
    {
        oid: "00000008-0000-0000-0000-000000000000",
        sort: 8,
        visit_status: VisitStatus.REVIEW,
        tooltip: "Review - Particpant has left the Clinic and is under review",
        name: "Review",
        code: "Re",
        status: "review",
        icon: "davesa:visit-review",
        icon2: "davesa:v-review",
        icon3: "mat_solid:check",
        textClass: "text-emerald-800",
        bgClass: "bg-emerald-800",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#005f5a",

    },
    {
        oid: "00000009-0000-0000-0000-000000000000",
        sort: 9,
        visit_status: VisitStatus.FINISHED,
        tooltip: "Finished - Coordinator has finished the visit",
        name: "Finished",
        code: "Fi",
        status: "finished",
        icon: "davesa:visit-finished",
        icon2: "davesa:v-finished",
        icon3: "mat_solid:check",
        textClass: "text-emerald-900",
        bgClass: "bg-emerald-900",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#004f3b",

    },
    {
        oid: "00000010-0000-0000-0000-000000000000",
        sort: 10,
        visit_status: VisitStatus.VALIDATED,
        tooltip: "Validated - Visit has been validated by Sub-Investigator",
        name: "Validated",
        code: "Va",
        status: "validated",
        icon: "davesa:visit-validated",
        icon2: "davesa:v-validated",
        icon3: "mat_solid:check",
        textClass: "text-emerald-950",
        bgClass: "bg-emerald-950",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#002c22",

    },
    {
        oid: "00000011-0000-0000-0000-000000000000",
        sort: 11,
        visit_status: VisitStatus.ENDORSED,
        tooltip: "Endorsed - Visit has been endorsed by Principal Investigator",
        name: "Endorsed",
        code: "En",
        status: "endorsed",
        icon: "davesa:visit-endorsed",
        icon2: "davesa:v-endorsed",
        icon3: "mat_solid:check",
        textClass: "text-teal-950",
        bgClass: "bg-teal-950",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#002c22",
    },
    {
        oid: "00000012-0000-0000-0000-000000000000",
        sort: 12,
        visit_status: VisitStatus.MONITOR,
        tooltip: "Monitor - Visit is being monitored by Sponsor",
        name: "Monitor",
        code: "Mo",
        status: "monitor",
        icon: "davesa:visit-monitor",
        icon2: "davesa:v-monitor",
        icon3: "mat_solid:check",
        textClass: "text-zinc-900",
        bgClass: "bg-zinc-900",
        textClassContrast: "text-gray-100",
        bgClassContrast: "bg-gray-100",
        bgColor: "#18181b",

    },
];

export const visitStatusOld = [
    {
        oid: "00000001-0000-0000-0000-000000000000",
        sort: 1,
        visit_status: VisitStatus.SCHEDULE,
        tooltip: "Schedule - Visit needs to be scheduled",
        name: "Schedule",
        status: "schedule",
        icon: "davesa:visit-schedule",
        icon2: "davesa:v-schedule",
        icon3: "mat_solid:check",
        textClass: "text-gray-500",
        textClassContrast: "text-gray-900",
        bgClass: "bg-gray-200",
        bgClassContrast: "bg-gray-900",
    },
    {
        oid: "00000002-0000-0000-0000-000000000000",
        sort: 2,
        visit_status: VisitStatus.UNCONFIRMED,
        old: "schedule",
        tooltip: "Unconfirmed - Visit needs to be confirmed byu Participant",
        name: "Unconfirmed",
        status: "unconfirmed",
        icon: "davesa:visit-unconfirmed",
        icon2: "davesa:v-unconfirmed",
        icon3: "mat_solid:check",
        textClass: "text-cyan-500",
        textClassContrast: "text-white",
        bgClass: "bg-cyan-500",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000003-0000-0000-0000-000000000000",
        sort: 3,
        visit_status: VisitStatus.CONFIRMED,
        tooltip: "Confirmed - Visit has been confirmed by Participant",
        name: "Confirmed",
        status: "confirmed",
        icon: "davesa:visit-confirmed",
        icon2: "davesa:v-confirmed",
        icon3: "mat_solid:check",
        textClass: "text-cyan-700",
        textClassContrast: "text-white",
        bgClass: "bg-cyan-700",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000004-0000-0000-0000-000000000000",
        sort: 4,
        visit_status: VisitStatus.RESCHEDULE,
        tooltip: "Reschedule - Visit needs to be rescheduled",
        name: "Reschedule",
        status: "reschedule",
        icon: "davesa:visit-reschedule",
        icon2: "davesa:v-reschedule",
        icon3: "mat_solid:check",
        textClass: "text-lime-500",
        textClassContrast: "text-white",
        bgClass: "bg-lime-500",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000005-0000-0000-0000-000000000000",
        sort: 5,
        visit_status: VisitStatus.ABSENT,
        tooltip: "Absent - Participant was did not show up for the visit",
        name: "Absent",
        status: "absent",
        icon: "davesa:visit-absent",
        icon2: "davesa:v-absent",
        icon3: "mat_solid:check",

        textClass: "text-pink-500",
        textClassContrast: "text-white",
        bgClass: "bg-pink-500",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000006-0000-0000-0000-000000000000",
        sort: 6,
        visit_status: VisitStatus.MISSED,
        tooltip: "Missed - Visit was approved as missed by Sponsor",
        name: "Missed",
        status: "missed",
        icon: "davesa:visit-absent",
        icon2: "davesa:v-absent",
        icon3: "mat_solid:check",

        textClass: "text-roe-500",
        textClassContrast: "text-white",
        bgClass: "bg-rose-500",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000007-0000-0000-0000-000000000000",
        sort: 7,
        visit_status: VisitStatus.CLINIC,
        tooltip: "Clinic - Participant is in the Clinic now",
        name: "Clinic",
        status: "clinic",
        icon: "davesa:visit-clinic",
        icon2: "davesa:v-clinic",
        icon3: "mat_solid:check",

        textClass: "text-sky-500",
        textClassContrast: "text-white",
        bgClass: "bg-sky-500",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000008-0000-0000-0000-000000000000",
        sort: 8,
        visit_status: VisitStatus.REVIEW,
        tooltip: "Review - Particpant has left the Clinic and is under review",
        name: "Review",
        status: "review",
        icon: "davesa:visit-review",
        icon2: "davesa:v-review",
        icon3: "mat_solid:check",

        textClass: "text-emerald-400",
        textClassContrast: "text-white",
        bgClass: "bg-emerald-400",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000009-0000-0000-0000-000000000000",
        sort: 9,
        visit_status: VisitStatus.FINISHED,
        tooltip: "Finished - Coordinator has finished the visit",
        name: "Finished",
        status: "finished",
        icon: "davesa:visit-finished",
        icon2: "davesa:v-finished",
        icon3: "mat_solid:check",

        textClass: "text-emerald-600",
        textClassContrast: "text-white",
        bgClass: "bg-emerald-600",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000010-0000-0000-0000-000000000000",
        sort: 10,
        visit_status: VisitStatus.VALIDATED,
        tooltip: "Validated - Visit has been validated by Sub-Investigator",
        name: "Validated",
        status: "validated",
        icon: "davesa:visit-validated",
        icon2: "davesa:v-validated",
        icon3: "mat_solid:check",

        textClass: "text-emerald-700",
        textClassContrast: "text-white",
        bgClass: "bg-emerald-700",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000011-0000-0000-0000-000000000000",
        sort: 11,
        visit_status: VisitStatus.ENDORSED,
        tooltip: "Endorsed - Visit has been endorsed by Principal Investigator",
        name: "Endorsed",
        status: "endorsed",
        icon: "davesa:visit-endorsed",
        icon2: "davesa:v-endorsed",
        icon3: "mat_solid:check",

        textClass: "text-emerald-900",
        textClassContrast: "text-white",
        bgClass: "bg-emerald-900",
        bgClassContrast: "bg-white",
    },
    {
        oid: "00000012-0000-0000-0000-000000000000",
        sort: 12,
        visit_status: VisitStatus.MONITOR,
        tooltip: "Monitor - Visit is being monitored by Sponsor",
        name: "Monitor",
        status: "monitor",
        icon: "davesa:visit-monitor",
        icon2: "davesa:v-monitor",
        icon3: "mat_solid:check",

        textClass: "text-emerald-950",
        textClassContrast: "text-white",
        bgClass: "bg-emerald-950",
        bgClassContrast: "bg-white",
    },
];
